module.exports = __webpack_public_path__ + "static/media/stjala.6d5884be.mp3";